import { Base } from '../core/base.model';

/**
 * Resumen de dashboard.do. Los totales, porCategoria, porEstatus,
 * anonimas/confidenciales y porMes respetan el periodo enviado;
 * sinAsignar, sinAtender y tiempoMedioCierreHoras son foto del canal
 * completo. Los campos nuevos son opcionales para no obligar a los
 * consumidores previos (dashboard propio) a poblarlos.
 */
export class DenunciaDashboard extends Base {
  totalDenuncias:       number;
  totalRecibidas:       number;
  totalEnInvestigacion: number;
  totalCerradas:        number;
  porCategoria:         DenunciaGrafica[];
  porEstatus:           DenunciaGrafica[];

  sinAsignar?:             number;
  sinAtender?:             number;
  diasSinAtender?:         number;
  tiempoMedioCierreHoras?: number | null;
  anonimas?:               number;
  confidenciales?:         number;
  porMes?:                 DenunciaGrafica[];
}

export class DenunciaGrafica {
  nombre: string;
  total:  number;
  color?: string;
}
